import { useQuery } from '@tanstack/react-query';
import { useRouter } from '@tanstack/react-router';
import { useMemo } from 'react';
import type { AdminApi } from '../../../api/client.ts';
import { environmentsQuery } from '../../../api/queries.ts';
import { localeSettingsOf, type LocaleSettings } from './localization.ts';

/** The locales of an environment (BB-55) from the environment list; `undefined` until it is loaded. */
export function useEnvironmentLocales(environmentId: string): LocaleSettings | undefined {
  const { api } = useRouter().options.context as { api: AdminApi };
  const { data } = useQuery(environmentsQuery(api));
  const environment = data?.find((e) => e.id === environmentId);
  return useMemo(() => (environment ? localeSettingsOf(environment) : undefined), [environment]);
}
